import { Image } from '@graphcommerce/image'
import { responsiveVal } from '@graphcommerce/next-ui'
import { Box, Typography } from '@mui/material'
import { DiyStepFragment } from './DiyStep.gql'

export type DiyStepProps = DiyStepFragment & {
  index: number
}

export function DiyStep(props: DiyStepProps) {
  const { diy_step_title, image, index } = props

  return (
    <Box sx={(theme) => ({ position: 'relative', mb: theme.spacings.md })}>
      <Image
        loading='eager'
        style={{ objectFit: 'contain' }}
        layout='responsive'
        src={image.url}
        width={100}
        height={100}
        sizes='350px'
        sx={(theme) => ({ display: 'block', mb: theme.spacings.xs })}
      />
      <Box
        sx={(theme) => ({
          height: { xs: 40, lg: 55 },
          paddingTop: '3px',
          typography: 'h3',
          background: theme.palette.secondary.main,
          display: 'inline-flex',
          color: theme.palette.primary.contrastText,
          position: 'absolute',
          left: { xs: 20, sm: 30 },
          top: 0,
          width: { xs: 40, lg: 55 },
          alignItems: 'center',
          justifyContent: 'center',
          '&:after': {
            borderColor: `${theme.palette.secondary.main} transparent transparent`,
            borderWidth: { xs: `6px 28px 0px 12px`, lg: `8px 38px 0px 17px` },
            content: '" "',
            display: 'inline-block',
            width: '100%',
            height: '10px',
            position: 'absolute',
            top: '100%',
            borderStyle: 'solid',
          },
        })}
      >
        {index + 1}
      </Box>
      <Typography variant='subtitle1' sx={(theme) => ({ my: theme.spacings.sm })}>
        {diy_step_title}
      </Typography>
    </Box>
  )
}
